import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import { ReportContext } from "../../layout/Content/MainContent.component";
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import ClipLoader from "react-spinners/ClipLoader";
import moment from "moment-timezone"

import { createMuiTheme, withStyles, ThemeProvider } from "@material-ui/core/styles";
import { Typography, Switch } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import "./PaginationTable.css";
import useOptimzationReportStyles from "./optimizationReport.style";

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 700
  },
  name: {
    fontFamily: "OpenSans",
    fontWeight: 600
  },
  divider: {
    borderLeft: "1px solid",
    margin: "3px 7px",
    height: 15
  },
  text: {
    fontFamily: "OpenSans",
    fontSize: "0.75rem",
    color: "#999",
    alignItems: "center"
  },
  textBold: {
    marginLeft: 3,
    fontWeight: 600
  },
  tableCont: {
    marginTop: "20px !important"
  },
  root: {
    display: "inline-flex",
    marginRight: theme.spacing(0.75),
    height: "1.3rem",
    alignItems: "center",
    marginBottom: theme.spacing(0.25),
  },
  refreshLabel: {
    fontSize: "12px",
    color: "#000",
    fontFamily: "OpenSans",
    fontWeight: "bold",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(-0.5),
    width: "max-content",
    "&:hover": {
      cursor: "default",
    },
  },
  sharedWrap: {
    cursor: "pointer",
    // marginBottom: theme.spacing(0.5),
  },

}));
const theme = createMuiTheme({
  palette: {
    primary: green
  }
});

const BodyTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    border: "1px solid #dde6ed",
    fontFamily: "OpenSansBold",
    fontSize: "0.8rem !important",
    position: "sticky",
    top: 42
  },
  body: {
    fontSize: 14,
    border: "1px solid #dde6ed"
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f9fc"
    }
  },
}))(TableRow);
const ISO_DATE_FORMAT = "MM/DD/YYYY, hh:MM A"
const formatdate = date => {
  return moment(date).format(ISO_DATE_FORMAT);
}

export default function OptimizationReport(props) {
  const {
    activeTab,
    handleNext,
    handlePrev,
    navigateToOptimizationOutput,
    setReportId,
    enableAutoRefresh,
    toggleAutoRefresh
  } = React.useContext(ReportContext);

  const classes = useStyles();
  const newclasses = useOptimzationReportStyles();
  const [state, setState] = useState([]);
  const { data, fetchData, loading } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // const [dense, setDense] = React.useState(false);
  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
  const isCompleted = status => status == "Completed";
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function showOptReport(data) {
    //alert("HI");
    //console.log("Optimzation Report");
    setReportId(data.reportId)
    navigateToOptimizationOutput();
  }
  return (
    <React.Fragment>
      <TableContainer className={classes.tableCont} component={Paper} style={{ marginTop: "20px", maxHeight: "calc(100vh - 260px)" }}>
        <div
          style={{
            display: "flex",
            height: 32,
            alignItems: "center",
            padding: "5px 10px",
            position: "sticky",
            top: 0,
            backgroundColor: "inherit"
          }}
        >
          <div className={classes.name}>Optimization Reports Status</div>
          <div style={{ marginLeft: "auto" }}>
            <div className={classes.root}>
              <div className={classes.sharedWrap} data-it-id="auto-refresh-switch">
                <Switch
                  color="primary"
                  value="shared"
                  checked={enableAutoRefresh}
                  onChange={toggleAutoRefresh}
                />
              </div>
              <Typography className={classes.refreshLabel} gutterBottom>
                Auto Refresh
      </Typography>
            </div>

            <IconButton onClick={fetchData}>
              <RefreshIcon />
            </IconButton>
          </div>
        </div>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <BodyTableCell>Report ID</BodyTableCell>
              <BodyTableCell align="center">Network</BodyTableCell>
              <BodyTableCell align="center">Year</BodyTableCell>
              <BodyTableCell align="center">Week</BodyTableCell>
              <BodyTableCell align="center">Status</BodyTableCell>
              <BodyTableCell align="center">Run Date</BodyTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const complete = isCompleted(row.status);
                return (
                  <StyledTableRow key={index}>
                    <BodyTableCell scope="row">
                      {row.reportId}
                    </BodyTableCell>
                    <BodyTableCell align="center">
                      {row.networkDisplayName}
                    </BodyTableCell>
                    <BodyTableCell align="center">{row.year}</BodyTableCell>
                    <BodyTableCell align="center">
                      {row.weekId} ({row.period})
                    </BodyTableCell>
                    <BodyTableCell
                      align="center"
                      style={{ color: complete ? "blue" : "black", cursor: complete ? "pointer" : "default" }}
                    >
                      {row.status === "Completed" ? (
                        <div
                          onClick={() => {
                            showOptReport(row);
                          }}
                        >
                          {row.status}
                        </div>
                      ) : (
                          row.status
                        )}
                    </BodyTableCell>
                    <BodyTableCell align="center">
                      {formatdate(row.createdAt)}
                    </BodyTableCell>
                  </StyledTableRow>
                );
              })}
            {loading && <td colSpan={6}><center>
              <ClipLoader
                color={"#1976d2"}
                align="center"
                loading={loading}
                size={80}
              />
            </center></td>}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </React.Fragment>
  );
}
